import React from "react";
import "./App.css";
import "./css/investStyle.css";
import "./css/investGraf.css";
import "./css/investRenta.css";
import "./css/investOdporucania.css";
import "./css/investVyvoj.css";
import "./css/investPdf.css";
import Navbar from "./components/Navbar_menu";
import InvesticneVstupneParametreKarta from "./components/investicna/InvesticneVstupneParametreKarta";
import InvesticnePoplatkyKarta from "./components/investicna/InvesticnePoplatkyKarta";
import InvesticneVystupyKarta from "./components/investicna/InvesticneVystupyKarta";
import InvesticneGrafickeZobrazenieKarta from "./components/investicna/InvesticneGrafickeZobrazenieKarta";
import InvesticieTrhBanner from "./components/investicna/InvesticieTrhBanner";
import { vypocitajInvesticnuKalkulacku } from "./utils/investKal";
import InvesticneRozsireneMoznostiKarta from "./components/investicna/InvesticneRozsireneMoznostiKarta";
import PoznamkaKarta from "./components/kalkulacka/PoznamkaKarta";
import InvesticneScenareVstupKarta from "./components/investicna/InvesticneScenareVstupKarta";
import InvesticneScenareVystupKarta from "./components/investicna/InvesticneScenareVystupKarta";
import InvesticneRentaVstupKarta from "./components/investicna/InvesticneRentaVstupKarta";
import InvesticneRentaVystupKarta from "./components/investicna/InvesticneRentaVystupKarta";
import InvesticneOdporucaniaVstupKarta from "./components/investicna/InvesticneOdporucaniaVstupKarta";
import InvesticneVyvojInvesticieKarta from "./components/investicna/InvesticneVyvojInvesticieKarta";
import InvesticneExportPonukaPdfModal from "./components/investicna/InvesticneExportPonukaPdfModal";
import { vytvorDataPreInvesticnuPonukuPdf, vytvorPredvoleneInvestPdfSekcie, } from "./utils/investPonukaPdfData";
import { exportInvesticnaPonukaPdf, } from "./utils/exportInvesticnaPonukaPdf";
import { maInvestPdfRentu, maInvestPdfScenare, } from "./utils/investPdfRozsireneMoznosti";
import { maInvestPdfOdporucania, } from "./utils/investPdfOdporucania";
import { maInvestPdfPoznamku, maInvestPdfVyvoj, pripravInvestPdfVyvoj, } from "./utils/investPdfPoznamkyVyvoj";
import { useAuth, } from "./auth/AuthContext";

const vytvorPociatocneInvesticneScenare = () => ([
  {
    id: "pesimisticky",
    nazov: "Pesimistický",
    jednorazovyVklad: 0,
    mesacnyVklad: 100,
    horizont: 30,
    zhodnotenie: 6,
  },
  {
    id: "realisticky",
    nazov: "Realistický",
    jednorazovyVklad: 0,
    mesacnyVklad: 100,
    horizont: 30,
    zhodnotenie: 8,
  },
  {
    id: "optimisticky",
    nazov: "Optimistický",
    jednorazovyVklad: 0,
    mesacnyVklad: 100,
    horizont: 30,
    zhodnotenie: 10,
  },
]);

const POCET_MESIACOV_V_ROKU = 12;
const MAXIMALNY_HORIZONT_CIELOVEJ_SUMY = 50;
const MAXIMALNA_AUTOMATICKA_CIELOVA_SUMA = 9999999;
const DYNAMICKY_INVESTICNY_PROFIL =
  Object.freeze({
    kluc: "dynamicky",
    zhodnotenie: 9,
  });

const vypocitajAutomatickuCielovuSumu = (
  mesacnyVkladHodnota,
  jednorazovyVkladHodnota,
  horizontHodnota
) => {
  const mesacnyVkladCislo = Math.max(
    0,
    Number(mesacnyVkladHodnota) || 0
  );

  const jednorazovyVkladCislo =
    Math.max(
      0,
      Number(
        jednorazovyVkladHodnota
      ) || 0
    );

  const horizontCislo = Math.min(
    MAXIMALNY_HORIZONT_CIELOVEJ_SUMY,
    Math.max(
      0,
      Number(horizontHodnota) || 0
    )
  );

  if (
    mesacnyVkladCislo <= 0 ||
    horizontCislo <= 0
  ) {
    return 0;
  }

  const pravidelneVklady =
    mesacnyVkladCislo *
    POCET_MESIACOV_V_ROKU *
    horizontCislo;

  const pociatocnyVkladVKombinacii =
    jednorazovyVkladCislo > 0
      ? jednorazovyVkladCislo
      : 0;

  return Math.min(
    MAXIMALNA_AUTOMATICKA_CIELOVA_SUMA,
    pravidelneVklady +
      pociatocnyVkladVKombinacii
  );
};

export default function InvesticnaKalkulacka() {
  const { user } = useAuth();
  const investicneGrafyPdfRef = React.useRef(null);
  const investicneOdporucaniaPdfRef = React.useRef(null);
  const [investicnyProfil, setInvesticnyProfil] = React.useState( DYNAMICKY_INVESTICNY_PROFIL.kluc );
  const [jednorazovyVklad, setJednorazovyVklad] = React.useState(0);
  const [jednorazovyPrivkladZapnuty, setJednorazovyPrivkladZapnuty] = React.useState(false);
  const [jednorazovyPrivklad, setJednorazovyPrivklad] = React.useState(0);
  const [jednorazovyPrivkladMesiac, setJednorazovyPrivkladMesiac] = React.useState(0);
  const [mesacnyVklad, setMesacnyVklad] = React.useState(150);
  const [cielovaSuma, setCielovaSuma] = React.useState(0);
  const [zhodnotenie, setZhodnotenie] = React.useState( DYNAMICKY_INVESTICNY_PROFIL.zhodnotenie );
  const [horizont, setHorizont] = React.useState(25);
  const [dodatocneZhodnocovanieZapnute, setDodatocneZhodnocovanieZapnute] = React.useState(false);
  const [dodatocneZhodnocovanieRoky, setDodatocneZhodnocovanieRoky] = React.useState(0);

  const [typPoplatku, setTypPoplatku] = React.useState("jednorazovy");
  const [jednorazovyPoplatok, setJednorazovyPoplatok] = React.useState(0);
  const [rozlozenyPoplatokPercento, setRozlozenyPoplatokPercento] = React.useState(0);
  const [maxRozlozenyPoplatokZVkladuPercento, setMaxRozlozenyPoplatokZVkladuPercento] = React.useState(50);
  const [priebeznyPoplatokPercento, setPriebeznyPoplatokPercento] = React.useState(0);
  const [manazerskyPoplatok, setManazerskyPoplatok] = React.useState(0);

  const [typPoplatku2, setTypPoplatku2] = React.useState("jednorazovy");
  const [jednorazovyPoplatok2, setJednorazovyPoplatok2] = React.useState(0);
  const [rozlozenyPoplatokPercento2, setRozlozenyPoplatokPercento2] = React.useState(0);
  const [maxRozlozenyPoplatokZVkladuPercento2, setMaxRozlozenyPoplatokZVkladuPercento2] = React.useState(50);
  const [priebeznyPoplatokPercento2, setPriebeznyPoplatokPercento2] = React.useState(0);
  const [manazerskyPoplatok2, setManazerskyPoplatok2] = React.useState(0);

  const [inflacia, setInflacia] = React.useState(2);
  const [rezimNavysovaniaVkladu, setRezimNavysovaniaVkladu] = React.useState("ziadne");
  const [fixneNavysenieVkladu, setFixneNavysenieVkladu] = React.useState(0);
  const [porovnanieInvesticii, setPorovnanieInvesticii] = React.useState(true);
  const [aktivnyInvesticnyVariant, setAktivnyInvesticnyVariant] = React.useState(1);

  const [investicnyProfil2, setInvesticnyProfil2] = React.useState( DYNAMICKY_INVESTICNY_PROFIL.kluc );
  const [jednorazovyVklad2, setJednorazovyVklad2] = React.useState(0);
  const [jednorazovyPrivkladZapnuty2, setJednorazovyPrivkladZapnuty2] = React.useState(false);
  const [jednorazovyPrivklad2, setJednorazovyPrivklad2] = React.useState(0);
  const [jednorazovyPrivkladMesiac2, setJednorazovyPrivkladMesiac2] = React.useState(0);
  const [mesacnyVklad2, setMesacnyVklad2] = React.useState(100);
  const [cielovaSuma2, setCielovaSuma2] = React.useState(0);
  const [zhodnotenie2, setZhodnotenie2] = React.useState( DYNAMICKY_INVESTICNY_PROFIL.zhodnotenie );
  const [horizont2, setHorizont2] = React.useState(20);
  const [dodatocneZhodnocovanieZapnute2, setDodatocneZhodnocovanieZapnute2] = React.useState(false);
  const [dodatocneZhodnocovanieRoky2, setDodatocneZhodnocovanieRoky2] = React.useState(0);
  const [inflacia2, setInflacia2] = React.useState(2);
  const [rezimNavysovaniaVkladu2, setRezimNavysovaniaVkladu2] = React.useState("ziadne");
  const [fixneNavysenieVkladu2, setFixneNavysenieVkladu2] = React.useState(0);
  const [danovyRezim, setDanovyRezim] = React.useState("bezDane");
  const [sadzbaDane, setSadzbaDane] = React.useState(19);
  const [danovyRezim2, setDanovyRezim2] = React.useState("bezDane");
  const [sadzbaDane2, setSadzbaDane2] = React.useState(19);
  const [investScenareOpen, setInvestScenareOpen] = React.useState(false);
  const [investRentaOpen, setInvestRentaOpen] = React.useState(false);
  const [vyvojInvesticieRezim, setVyvojInvesticieRezim] = React.useState(null);
  const [poznamkaInvesticie, setPoznamkaInvesticie] = React.useState("");
  const [investicneScenare, setInvesticneScenare] = React.useState(vytvorPociatocneInvesticneScenare);
  const [porovnajScenare, setPorovnajScenare] = React.useState(true);
  const [rentaKapital, setRentaKapital] = React.useState(100000);
  const [rentaKapitalRoky, setRentaKapitalRoky] = React.useState(20);
  const [rentaKapitalZhodnotenie, setRentaKapitalZhodnotenie] = React.useState(4);
  const [rentaMesacne, setRentaMesacne] = React.useState(1000);
  const [rentaMesacneRoky, setRentaMesacneRoky] = React.useState(20);
  const [rentaMesacneZhodnotenie, setRentaMesacneZhodnotenie] = React.useState(4);
  const [investicneOdporucaniaResetKey, setInvesticneOdporucaniaResetKey] = React.useState(0);
  const [nazovSuboruInvestPdf, setNazovSuboruInvestPdf, ] = React.useState("Ponuka_investicie");
  const [menoKlientaInvestPdf, setMenoKlientaInvestPdf, ] = React.useState("");
  const [investPdfModalOtvoreny, setInvestPdfModalOtvoreny, ] = React.useState(false);
  const [investPdfGenerujeSa, setInvestPdfGenerujeSa,] = React.useState(false);
  const [investPdfChyba, setInvestPdfChyba,] = React.useState("");
  const [investPdfSekcie, setInvestPdfSekcie,] = React.useState(() => vytvorPredvoleneInvestPdfSekcie());

  const [
    investPdfOdporucania,
    setInvestPdfOdporucania,
  ] = React.useState(null);

  React.useEffect(() => {
    setCielovaSuma(
      vypocitajAutomatickuCielovuSumu(
        mesacnyVklad,
        jednorazovyVklad,
        horizont
      )
    );
  }, [
    mesacnyVklad,
    jednorazovyVklad,
    horizont,
  ]);

  React.useEffect(() => {
    setCielovaSuma2(
      vypocitajAutomatickuCielovuSumu(
        mesacnyVklad2,
        jednorazovyVklad2,
        horizont2
      )
    );
  }, [
    mesacnyVklad2,
    jednorazovyVklad2,
    horizont2,
  ]);

  React.useEffect(() => {
    if (!porovnanieInvesticii && aktivnyInvesticnyVariant !== 1) {
      setAktivnyInvesticnyVariant(1);
    }
  }, [porovnanieInvesticii, aktivnyInvesticnyVariant]);

  const setInvesticnyScenar = React.useCallback((index, zmeny) => {
    setInvesticneScenare((povodneScenare) => (
      povodneScenare.map((scenar, scenarIndex) => (
        scenarIndex === index
          ? { ...scenar, ...zmeny }
          : scenar
      ))
    ));
  }, []);

  const resetujInvesticnuKalkulacku = React.useCallback(() => {
    setInvesticnyProfil(
      DYNAMICKY_INVESTICNY_PROFIL.kluc
    );
    setJednorazovyVklad(0);
    setJednorazovyPrivkladZapnuty(false);
    setJednorazovyPrivklad(0);
    setJednorazovyPrivkladMesiac(0);
    setMesacnyVklad(0);
    setCielovaSuma(0);
    setZhodnotenie(
      DYNAMICKY_INVESTICNY_PROFIL
        .zhodnotenie
    );
    setHorizont(0);
    setDodatocneZhodnocovanieZapnute(false);
    setDodatocneZhodnocovanieRoky(0);

    setTypPoplatku("jednorazovy");
    setJednorazovyPoplatok(0);
    setRozlozenyPoplatokPercento(0);
    setMaxRozlozenyPoplatokZVkladuPercento(50);
    setPriebeznyPoplatokPercento(0);
    setManazerskyPoplatok(0);

    setInvesticnyProfil2(
      DYNAMICKY_INVESTICNY_PROFIL.kluc
    );
    setJednorazovyVklad2(0);
    setJednorazovyPrivkladZapnuty2(false);
    setJednorazovyPrivklad2(0);
    setJednorazovyPrivkladMesiac2(0);
    setMesacnyVklad2(0);
    setCielovaSuma2(0);
    setZhodnotenie2(
      DYNAMICKY_INVESTICNY_PROFIL
        .zhodnotenie
    );
    setHorizont2(0);
    setDodatocneZhodnocovanieZapnute2(false);
    setDodatocneZhodnocovanieRoky2(0);

    setTypPoplatku2("jednorazovy");
    setJednorazovyPoplatok2(0);
    setRozlozenyPoplatokPercento2(0);
    setMaxRozlozenyPoplatokZVkladuPercento2(50);
    setPriebeznyPoplatokPercento2(0);
    setManazerskyPoplatok2(0);

    setInflacia(0);
    setInflacia2(0);
    setRezimNavysovaniaVkladu("ziadne");
    setRezimNavysovaniaVkladu2("ziadne");
    setFixneNavysenieVkladu(0);
    setFixneNavysenieVkladu2(0);

    setDanovyRezim("bezDane");
    setSadzbaDane(19);
    setDanovyRezim2("bezDane");
    setSadzbaDane2(19);

    setPorovnanieInvesticii(false);
    setAktivnyInvesticnyVariant(1);
    setInvestScenareOpen(false);
    setInvestRentaOpen(false);
    setVyvojInvesticieRezim(null);
    setPoznamkaInvesticie("");
    setInvesticneScenare(vytvorPociatocneInvesticneScenare());
    setPorovnajScenare(true);
    setRentaKapital(100000);
    setRentaKapitalRoky(20);
    setRentaKapitalZhodnotenie(4);
    setRentaMesacne(1000);
    setRentaMesacneRoky(20);
    setRentaMesacneZhodnotenie(4);

    setNazovSuboruInvestPdf(
      "Ponuka_investicie"
    );
    setMenoKlientaInvestPdf("");
    setInvestPdfModalOtvoreny(false);
    setInvestPdfGenerujeSa(false);
    setInvestPdfChyba("");
    setInvestPdfSekcie(
      vytvorPredvoleneInvestPdfSekcie()
    );

    setInvesticneOdporucaniaResetKey((povodnyKluc) => povodnyKluc + 1);
  }, []);

  const jeVariant2 = porovnanieInvesticii && aktivnyInvesticnyVariant === 2;

  const aktivnyInvesticnyProfil = jeVariant2 ? investicnyProfil2 : investicnyProfil;
  const setAktivnyInvesticnyProfil = jeVariant2 ? setInvesticnyProfil2 : setInvesticnyProfil;
  const aktivnyJednorazovyVklad = jeVariant2 ? jednorazovyVklad2 : jednorazovyVklad;
  const setAktivnyJednorazovyVklad = jeVariant2 ? setJednorazovyVklad2 : setJednorazovyVklad;
  const aktivnyJednorazovyPrivkladZapnuty = jeVariant2 ? jednorazovyPrivkladZapnuty2 : jednorazovyPrivkladZapnuty;
  const setAktivnyJednorazovyPrivkladZapnuty = jeVariant2 ? setJednorazovyPrivkladZapnuty2 : setJednorazovyPrivkladZapnuty;
  const aktivnyJednorazovyPrivklad = jeVariant2 ? jednorazovyPrivklad2 : jednorazovyPrivklad;
  const setAktivnyJednorazovyPrivklad = jeVariant2 ? setJednorazovyPrivklad2 : setJednorazovyPrivklad;
  const aktivnyJednorazovyPrivkladMesiac = jeVariant2 ? jednorazovyPrivkladMesiac2 : jednorazovyPrivkladMesiac;
  const setAktivnyJednorazovyPrivkladMesiac = jeVariant2 ? setJednorazovyPrivkladMesiac2 : setJednorazovyPrivkladMesiac;
  const aktivnyMesacnyVklad = jeVariant2 ? mesacnyVklad2 : mesacnyVklad;
  const setAktivnyMesacnyVklad = jeVariant2 ? setMesacnyVklad2 : setMesacnyVklad;
  const aktivnaCielovaSuma = jeVariant2 ? cielovaSuma2 : cielovaSuma;
  const setAktivnaCielovaSuma = jeVariant2 ? setCielovaSuma2 : setCielovaSuma;
  const aktivneZhodnotenie = jeVariant2 ? zhodnotenie2 : zhodnotenie;
  const setAktivneZhodnotenie = jeVariant2 ? setZhodnotenie2 : setZhodnotenie;
  const aktivnyHorizont = jeVariant2 ? horizont2 : horizont;
  const setAktivnyHorizont = jeVariant2 ? setHorizont2 : setHorizont;
  const aktivneDodatocneZhodnocovanieZapnute = jeVariant2 ? dodatocneZhodnocovanieZapnute2 : dodatocneZhodnocovanieZapnute;
  const setAktivneDodatocneZhodnocovanieZapnute = jeVariant2 ? setDodatocneZhodnocovanieZapnute2 : setDodatocneZhodnocovanieZapnute;
  const aktivneDodatocneZhodnocovanieRoky = jeVariant2 ? dodatocneZhodnocovanieRoky2 : dodatocneZhodnocovanieRoky;
  const setAktivneDodatocneZhodnocovanieRoky = jeVariant2 ? setDodatocneZhodnocovanieRoky2 : setDodatocneZhodnocovanieRoky;
  const aktivnaInflacia = jeVariant2 ? inflacia2 : inflacia;
  const setAktivnaInflacia = jeVariant2 ? setInflacia2 : setInflacia;
  const aktivnyRezimNavysovaniaVkladu = jeVariant2 ? rezimNavysovaniaVkladu2 : rezimNavysovaniaVkladu;
  const setAktivnyRezimNavysovaniaVkladu = jeVariant2 ? setRezimNavysovaniaVkladu2 : setRezimNavysovaniaVkladu;
  const aktivneFixneNavysenieVkladu = jeVariant2 ? fixneNavysenieVkladu2 : fixneNavysenieVkladu;
  const setAktivneFixneNavysenieVkladu = jeVariant2 ? setFixneNavysenieVkladu2 : setFixneNavysenieVkladu;

  const aktivnyTypPoplatku = jeVariant2 ? typPoplatku2 : typPoplatku;
  const setAktivnyTypPoplatku = jeVariant2 ? setTypPoplatku2 : setTypPoplatku;
  const aktivnyJednorazovyPoplatok = jeVariant2 ? jednorazovyPoplatok2 : jednorazovyPoplatok;
  const setAktivnyJednorazovyPoplatok = jeVariant2 ? setJednorazovyPoplatok2 : setJednorazovyPoplatok;
  const aktivnyRozlozenyPoplatokPercento = jeVariant2 ? rozlozenyPoplatokPercento2 : rozlozenyPoplatokPercento;
  const setAktivnyRozlozenyPoplatokPercento = jeVariant2 ? setRozlozenyPoplatokPercento2 : setRozlozenyPoplatokPercento;
  const aktivnyMaxRozlozenyPoplatokZVkladuPercento = jeVariant2 ? maxRozlozenyPoplatokZVkladuPercento2 : maxRozlozenyPoplatokZVkladuPercento;
  const setAktivnyMaxRozlozenyPoplatokZVkladuPercento = jeVariant2 ? setMaxRozlozenyPoplatokZVkladuPercento2 : setMaxRozlozenyPoplatokZVkladuPercento;
  const aktivnyPriebeznyPoplatokPercento = jeVariant2 ? priebeznyPoplatokPercento2 : priebeznyPoplatokPercento;
  const setAktivnyPriebeznyPoplatokPercento = jeVariant2 ? setPriebeznyPoplatokPercento2 : setPriebeznyPoplatokPercento;
  const aktivnyManazerskyPoplatok = jeVariant2 ? manazerskyPoplatok2 : manazerskyPoplatok;
  const setAktivnyManazerskyPoplatok = jeVariant2 ? setManazerskyPoplatok2 : setManazerskyPoplatok;
  const aktivnyDanovyRezim = jeVariant2 ? danovyRezim2 : danovyRezim;
  const setAktivnyDanovyRezim = jeVariant2 ? setDanovyRezim2 : setDanovyRezim;
  const aktivnaSadzbaDane = jeVariant2 ? sadzbaDane2 : sadzbaDane;
  const setAktivnaSadzbaDane = jeVariant2 ? setSadzbaDane2 : setSadzbaDane;

  const setZhodnotenieManualne = (hodnota) => {
    setAktivneZhodnotenie(hodnota);
  };

  const chybaCielovaSumaRozlozenyPoplatok =
    aktivnyTypPoplatku === "rozlozeny" &&
    Number(aktivnyRozlozenyPoplatokPercento) > 0 &&
    Number(aktivnaCielovaSuma) <= 0;

  const chybaMesacnyVkladPoplatok =
    (aktivnyTypPoplatku === "rozlozeny" && Number(aktivnyRozlozenyPoplatokPercento) > 0 && Number(aktivnyMesacnyVklad) <= 0) ||
    (aktivnyTypPoplatku === "priebežny" && Number(aktivnyPriebeznyPoplatokPercento) > 0 && Number(aktivnyMesacnyVklad) <= 0);

  const chybaMesacnyVkladNavysovanie =
    aktivnyRezimNavysovaniaVkladu !== "ziadne" &&
    Number(aktivnyMesacnyVklad) <= 0;

  const chybaCielovaSumaVstup =
    Number(aktivnaCielovaSuma) > 0 &&
    (Number(aktivnyMesacnyVklad) <= 0 || Number(aktivnyHorizont) <= 0);

  const chybaMesacnyVkladCielovaSuma =
    chybaCielovaSumaVstup && Number(aktivnyMesacnyVklad) <= 0;

  const chybaHorizontCielovaSuma =
    chybaCielovaSumaVstup && Number(aktivnyHorizont) <= 0;

  const chybaVstupneHodnoty =
    Number(aktivnyJednorazovyVklad) <= 0 &&
    Number(aktivnyMesacnyVklad) <= 0 &&
    (!aktivnyJednorazovyPrivkladZapnuty || Number(aktivnyJednorazovyPrivklad) <= 0);

  const chybaMesacnyVkladVstup =
    chybaMesacnyVkladPoplatok || chybaMesacnyVkladNavysovanie || chybaMesacnyVkladCielovaSuma;

  const vypocitajVariantInvesticie = React.useCallback(({
    jednorazovyVkladHodnota,
    jednorazovyPrivkladZapnutyHodnota,
    jednorazovyPrivkladHodnota,
    jednorazovyPrivkladMesiacHodnota,
    mesacnyVkladHodnota,
    cielovaSumaHodnota,
    zhodnotenieHodnota,
    horizontHodnota,
    dodatocneZhodnocovanieZapnuteHodnota,
    dodatocneZhodnocovanieRokyHodnota,
    inflaciaHodnota,
    rezimNavysovaniaVkladuHodnota,
    fixneNavysenieVkladuHodnota,
    typPoplatkuHodnota,
    jednorazovyPoplatokHodnota,
    rozlozenyPoplatokPercentoHodnota,
    maxRozlozenyPoplatokZVkladuPercentoHodnota,
    priebeznyPoplatokPercentoHodnota,
    manazerskyPoplatokHodnota,
    danovyRezimHodnota,
    sadzbaDaneHodnota,
  }) => (
    vypocitajInvesticnuKalkulacku({
      jednorazovyVklad: jednorazovyVkladHodnota,
      jednorazovyPrivkladZapnuty: jednorazovyPrivkladZapnutyHodnota,
      jednorazovyPrivklad: jednorazovyPrivkladHodnota,
      jednorazovyPrivkladMesiac: jednorazovyPrivkladMesiacHodnota,
      mesacnyVklad: mesacnyVkladHodnota,
      cielovaSuma: cielovaSumaHodnota,
      zhodnotenie: zhodnotenieHodnota,
      horizont: horizontHodnota,
      dodatocneZhodnocovanieZapnute: dodatocneZhodnocovanieZapnuteHodnota,
      dodatocneZhodnocovanieRoky: dodatocneZhodnocovanieRokyHodnota,
      typPoplatku: typPoplatkuHodnota,
      jednorazovyPoplatok: jednorazovyPoplatokHodnota,
      rozlozenyPoplatokPercento: rozlozenyPoplatokPercentoHodnota,
      maxRozlozenyPoplatokZVkladuPercento: maxRozlozenyPoplatokZVkladuPercentoHodnota,
      priebeznyPoplatokPercento: priebeznyPoplatokPercentoHodnota,
      manazerskyPoplatok: manazerskyPoplatokHodnota,
      inflacia: inflaciaHodnota,
      rezimNavysovaniaVkladu: rezimNavysovaniaVkladuHodnota,
      fixneNavysenieVkladu: fixneNavysenieVkladuHodnota,
      danovyRezim: danovyRezimHodnota,
      sadzbaDane: sadzbaDaneHodnota,
    })
  ), []);

  const vysledokVariant1 = React.useMemo(() => (
    vypocitajVariantInvesticie({
      jednorazovyVkladHodnota: jednorazovyVklad,
      jednorazovyPrivkladZapnutyHodnota: jednorazovyPrivkladZapnuty,
      jednorazovyPrivkladHodnota: jednorazovyPrivklad,
      jednorazovyPrivkladMesiacHodnota: jednorazovyPrivkladMesiac,
      mesacnyVkladHodnota: mesacnyVklad,
      cielovaSumaHodnota: cielovaSuma,
      zhodnotenieHodnota: zhodnotenie,
      horizontHodnota: horizont,
      dodatocneZhodnocovanieZapnuteHodnota: dodatocneZhodnocovanieZapnute,
      dodatocneZhodnocovanieRokyHodnota: dodatocneZhodnocovanieRoky,
      inflaciaHodnota: inflacia,
      rezimNavysovaniaVkladuHodnota: rezimNavysovaniaVkladu,
      fixneNavysenieVkladuHodnota: fixneNavysenieVkladu,
      typPoplatkuHodnota: typPoplatku,
      jednorazovyPoplatokHodnota: jednorazovyPoplatok,
      rozlozenyPoplatokPercentoHodnota: rozlozenyPoplatokPercento,
      maxRozlozenyPoplatokZVkladuPercentoHodnota: maxRozlozenyPoplatokZVkladuPercento,
      priebeznyPoplatokPercentoHodnota: priebeznyPoplatokPercento,
      manazerskyPoplatokHodnota: manazerskyPoplatok,
      danovyRezimHodnota: danovyRezim,
      sadzbaDaneHodnota: sadzbaDane,
    })
  ), [
    vypocitajVariantInvesticie,
    jednorazovyVklad,
    jednorazovyPrivkladZapnuty,
    jednorazovyPrivklad,
    jednorazovyPrivkladMesiac,
    mesacnyVklad,
    cielovaSuma,
    zhodnotenie,
    horizont,
    dodatocneZhodnocovanieZapnute,
    dodatocneZhodnocovanieRoky,
    inflacia,
    rezimNavysovaniaVkladu,
    fixneNavysenieVkladu,
    typPoplatku,
    jednorazovyPoplatok,
    rozlozenyPoplatokPercento,
    maxRozlozenyPoplatokZVkladuPercento,
    priebeznyPoplatokPercento,
    manazerskyPoplatok,
    danovyRezim,
    sadzbaDane,
  ]);

  const vysledokVariant2 = React.useMemo(() => (
    vypocitajVariantInvesticie({
      jednorazovyVkladHodnota: jednorazovyVklad2,
      jednorazovyPrivkladZapnutyHodnota: jednorazovyPrivkladZapnuty2,
      jednorazovyPrivkladHodnota: jednorazovyPrivklad2,
      jednorazovyPrivkladMesiacHodnota: jednorazovyPrivkladMesiac2,
      mesacnyVkladHodnota: mesacnyVklad2,
      cielovaSumaHodnota: cielovaSuma2,
      zhodnotenieHodnota: zhodnotenie2,
      horizontHodnota: horizont2,
      dodatocneZhodnocovanieZapnuteHodnota: dodatocneZhodnocovanieZapnute2,
      dodatocneZhodnocovanieRokyHodnota: dodatocneZhodnocovanieRoky2,
      inflaciaHodnota: inflacia2,
      rezimNavysovaniaVkladuHodnota: rezimNavysovaniaVkladu2,
      fixneNavysenieVkladuHodnota: fixneNavysenieVkladu2,
      typPoplatkuHodnota: typPoplatku2,
      jednorazovyPoplatokHodnota: jednorazovyPoplatok2,
      rozlozenyPoplatokPercentoHodnota: rozlozenyPoplatokPercento2,
      maxRozlozenyPoplatokZVkladuPercentoHodnota: maxRozlozenyPoplatokZVkladuPercento2,
      priebeznyPoplatokPercentoHodnota: priebeznyPoplatokPercento2,
      manazerskyPoplatokHodnota: manazerskyPoplatok2,
      danovyRezimHodnota: danovyRezim2,
      sadzbaDaneHodnota: sadzbaDane2,
    })
  ), [
    vypocitajVariantInvesticie,
    jednorazovyVklad2,
    jednorazovyPrivkladZapnuty2,
    jednorazovyPrivklad2,
    jednorazovyPrivkladMesiac2,
    mesacnyVklad2,
    cielovaSuma2,
    zhodnotenie2,
    horizont2,
    dodatocneZhodnocovanieZapnute2,
    dodatocneZhodnocovanieRoky2,
    inflacia2,
    rezimNavysovaniaVkladu2,
    fixneNavysenieVkladu2,
    typPoplatku2,
    jednorazovyPoplatok2,
    rozlozenyPoplatokPercento2,
    maxRozlozenyPoplatokZVkladuPercento2,
    priebeznyPoplatokPercento2,
    manazerskyPoplatok2,
    danovyRezim2,
    sadzbaDane2,
  ]);

  const vysledok = jeVariant2 ? vysledokVariant2 : vysledokVariant1;

  const rokyDoRenty = React.useMemo(() => (
    Math.max(0, Number(vysledok?.celkovaDobaInvesticieRoky) || 0)
  ), [vysledok]);

  const aktivnyVariantLabel = jeVariant2 ? "Variant 2" : "Variant 1";

  const vysledkyInvesticii =
    React.useMemo(
      () => ({
        variant1: vysledokVariant1,
        variant2:
          porovnanieInvesticii
            ? vysledokVariant2
            : null,
      }),
      [
        vysledokVariant1,
        vysledokVariant2,
        porovnanieInvesticii,
      ]
    );

  const nastaveniaVariantov =
    React.useMemo(
      () => ({
        variant1: {
          cielovaSuma,
          jednorazovyVklad,
          jednorazovyPrivkladZapnuty,
          jednorazovyPrivklad,
          jednorazovyPrivkladMesiac,
          typPoplatku,
          jednorazovyPoplatok,
        },

        variant2: {
          cielovaSuma:
            cielovaSuma2,
          jednorazovyVklad:
            jednorazovyVklad2,
          jednorazovyPrivkladZapnuty:
            jednorazovyPrivkladZapnuty2,
          jednorazovyPrivklad:
            jednorazovyPrivklad2,
          jednorazovyPrivkladMesiac:
            jednorazovyPrivkladMesiac2,
          typPoplatku:
            typPoplatku2,
          jednorazovyPoplatok:
            jednorazovyPoplatok2,
        },
      }),
      [
        cielovaSuma,
        jednorazovyVklad,
        jednorazovyPrivkladZapnuty,
        jednorazovyPrivklad,
        jednorazovyPrivkladMesiac,
        typPoplatku,
        jednorazovyPoplatok,

        cielovaSuma2,
        jednorazovyVklad2,
        jednorazovyPrivkladZapnuty2,
        jednorazovyPrivklad2,
        jednorazovyPrivkladMesiac2,
        typPoplatku2,
        jednorazovyPoplatok2,
      ]
    );

  const vysledkyScenarov = React.useMemo(() => (
    investicneScenare.map((scenar) => {
      const vysledokScenara = vypocitajInvesticnuKalkulacku({
        jednorazovyVklad: scenar.jednorazovyVklad,
        jednorazovyPrivkladZapnuty: false,
        jednorazovyPrivklad: 0,
        jednorazovyPrivkladMesiac: 0,
        mesacnyVklad: scenar.mesacnyVklad,
        cielovaSuma: 0,
        zhodnotenie: scenar.zhodnotenie,
        horizont: scenar.horizont,
        dodatocneZhodnocovanieZapnute: false,
        dodatocneZhodnocovanieRoky: 0,
        typPoplatku: "jednorazovy",
        jednorazovyPoplatok: 0,
        rozlozenyPoplatokPercento: 0,
        maxRozlozenyPoplatokZVkladuPercento: 50,
        priebeznyPoplatokPercento: 0,
        manazerskyPoplatok: 0,
        inflacia: 0,
        rezimNavysovaniaVkladu: "ziadne",
        fixneNavysenieVkladu: 0,
        danovyRezim: "bezDane",
        sadzbaDane: 0,
      });

      return {
        ...scenar,
        vysledok: vysledokScenara,
      };
    })
  ), [investicneScenare]);

  const dataRozsirenychMoznostiPreInvestPdf =
  React.useMemo(
    () => ({
      scenare: {
        otvorene: investScenareOpen,
        porovnajScenare,
        polozky: vysledkyScenarov,
      },
      renta: {
        otvorena: investRentaOpen,
        aktivnyVariantLabel,
        cielovaSuma:
          aktivnaCielovaSuma,
        vysledok,
        rentaKapital,
        rentaKapitalRoky,
        rentaKapitalZhodnotenie,
        rentaMesacne,
        rentaMesacneRoky,
        rentaMesacneZhodnotenie,
        inflacia: aktivnaInflacia,
      },
    }),
    [
      investScenareOpen,
      porovnajScenare,
      vysledkyScenarov,
      investRentaOpen,
      aktivnyVariantLabel,
      aktivnaCielovaSuma,
      vysledok,
      rentaKapital,
      rentaKapitalRoky,
      rentaKapitalZhodnotenie,
      rentaMesacne,
      rentaMesacneRoky,
      rentaMesacneZhodnotenie,
      aktivnaInflacia,
    ]
  );

const investPdfScenareDostupne =
  React.useMemo(
    () =>
      maInvestPdfScenare(
        dataRozsirenychMoznostiPreInvestPdf
          .scenare
      ),
    [
      dataRozsirenychMoznostiPreInvestPdf,
    ]
  );

const investPdfVyvoj =
  React.useMemo(
    () =>
      pripravInvestPdfVyvoj({
        aktivnyInvesticnyVariant,
        porovnanieInvesticii,
        vysledkyInvesticii,
        nastaveniaVariantov,
      }),
    [
      aktivnyInvesticnyVariant,
      porovnanieInvesticii,
      vysledkyInvesticii,
      nastaveniaVariantov,
    ]
  );

const investPdfRentaDostupna =
  React.useMemo(
    () =>
      maInvestPdfRentu(
        dataRozsirenychMoznostiPreInvestPdf
          .renta
      ),
    [
      dataRozsirenychMoznostiPreInvestPdf,
    ]
  );

  const dostupnostInvestPdfSekcii =
  React.useMemo(
    () => ({
      scenare:
        investPdfScenareDostupne,

      renta:
        investPdfRentaDostupna,

      poznamky:
        maInvestPdfPoznamku(
          poznamkaInvesticie
        ),

      vyvojInvesticie:
        maInvestPdfVyvoj(
          investPdfVyvoj
        ),

      navrhInvesticnehoRiesenia:
        maInvestPdfOdporucania(
          investPdfOdporucania
        ),
    }),
    [
      investPdfScenareDostupne,
      investPdfRentaDostupna,
      poznamkaInvesticie,
      investPdfVyvoj,
      investPdfOdporucania,
    ]
  );

  const dataVariantovPreInvestPdf =
    React.useMemo(
      () => ({
        porovnanieInvesticii,

        variant1: {
          investicnyProfil,
          jednorazovyVklad,
          mesacnyVklad,
          cielovaSuma,
          zhodnotenie,
          horizont,

          jednorazovyPrivkladZapnuty,
          jednorazovyPrivklad,
          jednorazovyPrivkladMesiac,

          inflacia,
          rezimNavysovaniaVkladu,
          fixneNavysenieVkladu,

          dodatocneZhodnocovanieZapnute,
          dodatocneZhodnocovanieRoky,

          typPoplatku,
          jednorazovyPoplatok,
          rozlozenyPoplatokPercento,
          maxRozlozenyPoplatokZVkladuPercento,
          priebeznyPoplatokPercento,
          manazerskyPoplatok,

          danovyRezim,
          sadzbaDane,
        },

        variant2: {
          investicnyProfil:
            investicnyProfil2,
          jednorazovyVklad:
            jednorazovyVklad2,
          mesacnyVklad:
            mesacnyVklad2,
          cielovaSuma:
            cielovaSuma2,
          zhodnotenie:
            zhodnotenie2,
          horizont:
            horizont2,

          jednorazovyPrivkladZapnuty:
            jednorazovyPrivkladZapnuty2,
          jednorazovyPrivklad:
            jednorazovyPrivklad2,
          jednorazovyPrivkladMesiac:
            jednorazovyPrivkladMesiac2,

          inflacia:
            inflacia2,
          rezimNavysovaniaVkladu:
            rezimNavysovaniaVkladu2,
          fixneNavysenieVkladu:
            fixneNavysenieVkladu2,

          dodatocneZhodnocovanieZapnute:
            dodatocneZhodnocovanieZapnute2,
          dodatocneZhodnocovanieRoky:
            dodatocneZhodnocovanieRoky2,

          typPoplatku:
            typPoplatku2,
          jednorazovyPoplatok:
            jednorazovyPoplatok2,
          rozlozenyPoplatokPercento:
            rozlozenyPoplatokPercento2,
          maxRozlozenyPoplatokZVkladuPercento:
            maxRozlozenyPoplatokZVkladuPercento2,
          priebeznyPoplatokPercento:
            priebeznyPoplatokPercento2,
          manazerskyPoplatok:
            manazerskyPoplatok2,

          danovyRezim:
            danovyRezim2,
          sadzbaDane:
            sadzbaDane2,
        },

        vysledkyInvesticii,
      }),
      [
        porovnanieInvesticii,

        investicnyProfil,
        jednorazovyVklad,
        mesacnyVklad,
        cielovaSuma,
        zhodnotenie,
        horizont,
        jednorazovyPrivkladZapnuty,
        jednorazovyPrivklad,
        jednorazovyPrivkladMesiac,
        inflacia,
        rezimNavysovaniaVkladu,
        fixneNavysenieVkladu,
        dodatocneZhodnocovanieZapnute,
        dodatocneZhodnocovanieRoky,
        typPoplatku,
        jednorazovyPoplatok,
        rozlozenyPoplatokPercento,
        maxRozlozenyPoplatokZVkladuPercento,
        priebeznyPoplatokPercento,
        manazerskyPoplatok,
        danovyRezim,
        sadzbaDane,

        investicnyProfil2,
        jednorazovyVklad2,
        mesacnyVklad2,
        cielovaSuma2,
        zhodnotenie2,
        horizont2,
        jednorazovyPrivkladZapnuty2,
        jednorazovyPrivklad2,
        jednorazovyPrivkladMesiac2,
        inflacia2,
        rezimNavysovaniaVkladu2,
        fixneNavysenieVkladu2,
        dodatocneZhodnocovanieZapnute2,
        dodatocneZhodnocovanieRoky2,
        typPoplatku2,
        jednorazovyPoplatok2,
        rozlozenyPoplatokPercento2,
        maxRozlozenyPoplatokZVkladuPercento2,
        priebeznyPoplatokPercento2,
        manazerskyPoplatok2,
        danovyRezim2,
        sadzbaDane2,

        vysledkyInvesticii,
      ]
    );

  const ulozInvesticnuPonukuPdf =
    React.useCallback(() => {
      const odporucania =
        investicneOdporucaniaPdfRef
          .current
          ?.ziskajPdfOdporucania?.() ||
        null;

      const aktualnaDostupnost = {
        ...dostupnostInvestPdfSekcii,

        navrhInvesticnehoRiesenia:
          maInvestPdfOdporucania(
            odporucania
          ),
      };

      setInvestPdfOdporucania(
        odporucania
      );

      setInvestPdfSekcie(
        vytvorPredvoleneInvestPdfSekcie(
          aktualnaDostupnost
        )
      );

      setInvestPdfChyba("");

      setInvestPdfModalOtvoreny(
        true
      );
    }, [
      dostupnostInvestPdfSekcii,
    ]);

  const zavriInvestPdfModal =
    React.useCallback(() => {
      if (investPdfGenerujeSa) {
        return;
      }

      setInvestPdfChyba("");
      setInvestPdfModalOtvoreny(
        false
      );
    }, [investPdfGenerujeSa]);

  const vygenerujInvesticnuPonukuPdf =
    React.useCallback(async () => {
      if (investPdfGenerujeSa) {
        return;
      }

      setInvestPdfGenerujeSa(true);
      setInvestPdfChyba("");

      try {
        const grafy =
          investicneGrafyPdfRef.current
            ?.ziskajPdfGrafy?.();

        if (
          !grafy?.zlozenie?.obrazok ||
          !grafy?.vyvoj?.obrazok
        ) {
          throw new Error(
            "Grafy nie sú pripravené na export."
          );
        }

        const dataPrePdf =
          vytvorDataPreInvesticnuPonukuPdf({
            nazovSuboru:
              nazovSuboruInvestPdf,
            menoKlienta:
              menoKlientaInvestPdf,
            kontaktMeno:
              user?.name || "",
            kontaktPriezvisko:
              user?.priezvisko || "",
            kontaktEmail:
              user?.email || "",
            kontaktTelefon:
              user?.telefon || "",
            kontaktNbsCislo:
              user?.nbsCislo || "",
            pdfSekcie:
              investPdfSekcie,
            dostupnostSekcii:
              dostupnostInvestPdfSekcii,
            grafy,
            scenare:
              dataRozsirenychMoznostiPreInvestPdf
                .scenare,
            renta:
              dataRozsirenychMoznostiPreInvestPdf
                .renta,
            odporucania:
              investPdfOdporucania,
            poznamka:
              poznamkaInvesticie,
            vyvojInvesticie:
              investPdfVyvoj,
            ...dataVariantovPreInvestPdf,
          });

        await exportInvesticnaPonukaPdf(
          dataPrePdf
        );

        setInvestPdfModalOtvoreny(
          false
        );
      } catch (chyba) {
        console.error(
          "Investičnú ponuku sa nepodarilo vygenerovať.",
          chyba
        );

        setInvestPdfChyba(
          "PDF sa nepodarilo vygenerovať. Skúste to znova."
        );
      } finally {
        setInvestPdfGenerujeSa(
          false
        );
      }
    }, [
      investPdfGenerujeSa,
      nazovSuboruInvestPdf,
      menoKlientaInvestPdf,
      user,
      investPdfSekcie,
      dostupnostInvestPdfSekcii,
      dataRozsirenychMoznostiPreInvestPdf,
      dataVariantovPreInvestPdf,
      investPdfOdporucania,
      poznamkaInvesticie,
      investPdfVyvoj,
    ]);

  return (
    <>
      <Navbar />
      <InvesticieTrhBanner />

      <div className="App" id="investicna">
        <div className="board board--investicna">
          <div className="col">
            <InvesticneVstupneParametreKarta
              porovnanieInvesticii={porovnanieInvesticii}
              setPorovnanieInvesticii={setPorovnanieInvesticii}
              aktivnyInvesticnyVariant={aktivnyInvesticnyVariant}
              setAktivnyInvesticnyVariant={setAktivnyInvesticnyVariant}
              investicnyProfil={aktivnyInvesticnyProfil}
              setInvesticnyProfil={setAktivnyInvesticnyProfil}
              setZhodnotenie={setAktivneZhodnotenie}
              jednorazovyVklad={aktivnyJednorazovyVklad}
              setJednorazovyVklad={setAktivnyJednorazovyVklad}
              jednorazovyPrivkladZapnuty={aktivnyJednorazovyPrivkladZapnuty}
              setJednorazovyPrivkladZapnuty={setAktivnyJednorazovyPrivkladZapnuty}
              jednorazovyPrivklad={aktivnyJednorazovyPrivklad}
              setJednorazovyPrivklad={setAktivnyJednorazovyPrivklad}
              jednorazovyPrivkladMesiac={aktivnyJednorazovyPrivkladMesiac}
              setJednorazovyPrivkladMesiac={setAktivnyJednorazovyPrivkladMesiac}
              mesacnyVklad={aktivnyMesacnyVklad}
              setMesacnyVklad={setAktivnyMesacnyVklad}
              cielovaSuma={aktivnaCielovaSuma}
              chybaCielovaSumaRozlozenyPoplatok={chybaCielovaSumaRozlozenyPoplatok}
              chybaMesacnyVkladNavysovanie={chybaMesacnyVkladNavysovanie}
              chybaMesacnyVkladCielovaSuma={chybaMesacnyVkladCielovaSuma}
              chybaHorizontCielovaSuma={chybaHorizontCielovaSuma}
              chybaVstupneHodnoty={chybaVstupneHodnoty}
              setCielovaSuma={setAktivnaCielovaSuma}
              zhodnotenie={aktivneZhodnotenie}
              setZhodnotenieManualne={setZhodnotenieManualne}
              horizont={aktivnyHorizont}
              setHorizont={setAktivnyHorizont}
              dodatocneZhodnocovanieZapnute={aktivneDodatocneZhodnocovanieZapnute}
              setDodatocneZhodnocovanieZapnute={setAktivneDodatocneZhodnocovanieZapnute}
              dodatocneZhodnocovanieRoky={aktivneDodatocneZhodnocovanieRoky}
              setDodatocneZhodnocovanieRoky={setAktivneDodatocneZhodnocovanieRoky}
              inflacia={aktivnaInflacia}
              setInflacia={setAktivnaInflacia}
              rezimNavysovaniaVkladu={aktivnyRezimNavysovaniaVkladu}
              setRezimNavysovaniaVkladu={setAktivnyRezimNavysovaniaVkladu}
              fixneNavysenieVkladu={aktivneFixneNavysenieVkladu}
              setFixneNavysenieVkladu={setAktivneFixneNavysenieVkladu}
              chybaMesacnyVkladPoplatok={chybaMesacnyVkladVstup}
            />

            <InvesticnePoplatkyKarta
              porovnanieInvesticii={porovnanieInvesticii}
              aktivnyInvesticnyVariant={aktivnyInvesticnyVariant}
              setAktivnyInvesticnyVariant={setAktivnyInvesticnyVariant}
              typPoplatku={aktivnyTypPoplatku}
              setTypPoplatku={setAktivnyTypPoplatku}
              jednorazovyPoplatok={aktivnyJednorazovyPoplatok}
              setJednorazovyPoplatok={setAktivnyJednorazovyPoplatok}
              rozlozenyPoplatokPercento={aktivnyRozlozenyPoplatokPercento}
              setRozlozenyPoplatokPercento={setAktivnyRozlozenyPoplatokPercento}
              maxRozlozenyPoplatokZVkladuPercento={aktivnyMaxRozlozenyPoplatokZVkladuPercento}
              setMaxRozlozenyPoplatokZVkladuPercento={setAktivnyMaxRozlozenyPoplatokZVkladuPercento}
              priebeznyPoplatokPercento={aktivnyPriebeznyPoplatokPercento}
              setPriebeznyPoplatokPercento={setAktivnyPriebeznyPoplatokPercento}
              manazerskyPoplatok={aktivnyManazerskyPoplatok}
              setManazerskyPoplatok={setAktivnyManazerskyPoplatok}
              danovyRezim={aktivnyDanovyRezim}
              setDanovyRezim={setAktivnyDanovyRezim}
              sadzbaDane={aktivnaSadzbaDane}
              setSadzbaDane={setAktivnaSadzbaDane}
              mesacnyVklad={aktivnyMesacnyVklad}
              cielovaSuma={aktivnaCielovaSuma}
              chybaCielovaSumaRozlozenyPoplatok={chybaCielovaSumaRozlozenyPoplatok}
              chybaMesacnyVkladPoplatok={chybaMesacnyVkladPoplatok}
            />

            <PoznamkaKarta
              poznamka={poznamkaInvesticie}
              setPoznamka={setPoznamkaInvesticie}
              className="card-section--invest-poznamka"
            />

            <InvesticneRozsireneMoznostiKarta
              investScenareOpen={investScenareOpen}
              setInvestScenareOpen={setInvestScenareOpen}
              investRentaOpen={investRentaOpen}
              setInvestRentaOpen={setInvestRentaOpen}
              vyvojInvesticieRezim={vyvojInvesticieRezim}
              setVyvojInvesticieRezim={setVyvojInvesticieRezim}
            />

          </div>

          <div className="col">
             <InvesticneVystupyKarta
              zhodnotenie={aktivneZhodnotenie}
              horizont={aktivnyHorizont}
              vysledok={vysledok}
              vysledkyInvesticii={vysledkyInvesticii}
              porovnanieInvesticii={porovnanieInvesticii}
              resetujAplikaciu={resetujInvesticnuKalkulacku}
              ulozPonukuPdf={ulozInvesticnuPonukuPdf}
            />
            <InvesticneGrafickeZobrazenieKarta
              ref={investicneGrafyPdfRef}
              vysledok={vysledok}
              vysledkyInvesticii={
                vysledkyInvesticii
              }
              porovnanieInvesticii={
                porovnanieInvesticii
              }
              nastaveniaVariantov={
                nastaveniaVariantov
              }
            />
          </div>

          <InvesticneScenareVstupKarta
            investScenareOpen={investScenareOpen}
            scenare={investicneScenare}
            setInvesticnyScenar={setInvesticnyScenar}
            porovnajScenare={porovnajScenare}
            setPorovnajScenare={setPorovnajScenare}
          />

          <InvesticneScenareVystupKarta
            investScenareOpen={investScenareOpen}
            vysledkyScenarov={vysledkyScenarov}
            porovnajScenare={porovnajScenare}
          />

          <InvesticneRentaVstupKarta
            investRentaOpen={investRentaOpen}
            rentaKapital={rentaKapital}
            setRentaKapital={setRentaKapital}
            rentaKapitalRoky={rentaKapitalRoky}
            setRentaKapitalRoky={setRentaKapitalRoky}
            rentaKapitalZhodnotenie={rentaKapitalZhodnotenie}
            setRentaKapitalZhodnotenie={setRentaKapitalZhodnotenie}
            rentaMesacne={rentaMesacne}
            setRentaMesacne={setRentaMesacne}
            rentaMesacneRoky={rentaMesacneRoky}
            setRentaMesacneRoky={setRentaMesacneRoky}
            rentaMesacneZhodnotenie={rentaMesacneZhodnotenie}
            setRentaMesacneZhodnotenie={setRentaMesacneZhodnotenie}
          />

          <InvesticneRentaVystupKarta
            investRentaOpen={investRentaOpen}
            aktivnyVariantLabel={aktivnyVariantLabel}
            cielovaSuma={aktivnaCielovaSuma}
            vysledok={vysledok}
            rentaKapital={rentaKapital}
            rentaKapitalRoky={rentaKapitalRoky}
            rentaKapitalZhodnotenie={rentaKapitalZhodnotenie}
            rentaMesacne={rentaMesacne}
            rentaMesacneRoky={rentaMesacneRoky}
            rentaMesacneZhodnotenie={rentaMesacneZhodnotenie}
            inflacia={aktivnaInflacia}
            rokyDoRenty={rokyDoRenty}
          />

          <InvesticneOdporucaniaVstupKarta
            key={investicneOdporucaniaResetKey}
            ref={investicneOdporucaniaPdfRef}
            porovnanieInvesticii={porovnanieInvesticii}
            aktivnyInvesticnyVariant={aktivnyInvesticnyVariant}
            setAktivnyInvesticnyVariant={setAktivnyInvesticnyVariant}
            variant1={{
              investicnyProfil,
              jednorazovyVklad,
              jednorazovyPrivkladZapnuty,
              jednorazovyPrivklad,
              jednorazovyPrivkladMesiac,
              mesacnyVklad,
              cielovaSuma,
              zhodnotenie,
              horizont,
              dodatocneZhodnocovanieZapnute,
              dodatocneZhodnocovanieRoky,
              inflacia,
              rezimNavysovaniaVkladu,
              fixneNavysenieVkladu,
              typPoplatku,
              jednorazovyPoplatok,
              rozlozenyPoplatokPercento,
              maxRozlozenyPoplatokZVkladuPercento,
              priebeznyPoplatokPercento,
              manazerskyPoplatok,
              danovyRezim,
              sadzbaDane,
              vysledok: vysledokVariant1,
              porovnanieInvesticii,
            }}
            variant2={{
              investicnyProfil: investicnyProfil2,
              jednorazovyVklad: jednorazovyVklad2,
              jednorazovyPrivkladZapnuty:
                jednorazovyPrivkladZapnuty2,
              jednorazovyPrivklad:
                jednorazovyPrivklad2,
              jednorazovyPrivkladMesiac:
                jednorazovyPrivkladMesiac2,
              mesacnyVklad: mesacnyVklad2,
              cielovaSuma: cielovaSuma2,
              zhodnotenie: zhodnotenie2,
              horizont: horizont2,
              dodatocneZhodnocovanieZapnute:
                dodatocneZhodnocovanieZapnute2,
              dodatocneZhodnocovanieRoky:
                dodatocneZhodnocovanieRoky2,
              inflacia: inflacia2,
              rezimNavysovaniaVkladu:
                rezimNavysovaniaVkladu2,
              fixneNavysenieVkladu:
                fixneNavysenieVkladu2,
              typPoplatku: typPoplatku2,
              jednorazovyPoplatok:
                jednorazovyPoplatok2,
              rozlozenyPoplatokPercento:
                rozlozenyPoplatokPercento2,
              maxRozlozenyPoplatokZVkladuPercento:
                maxRozlozenyPoplatokZVkladuPercento2,
              priebeznyPoplatokPercento:
                priebeznyPoplatokPercento2,
              manazerskyPoplatok:
                manazerskyPoplatok2,
              danovyRezim: danovyRezim2,
              sadzbaDane: sadzbaDane2,
              vysledok: vysledokVariant2,
              porovnanieInvesticii,
            }}
          />

          <InvesticneVyvojInvesticieKarta
            vyvojInvesticieRezim={
              vyvojInvesticieRezim
            }
            vysledkyInvesticii={
              vysledkyInvesticii
            }
            nastaveniaVariantov={
              nastaveniaVariantov
            }
            porovnanieInvesticii={
              porovnanieInvesticii
            }
            aktivnyInvesticnyVariant={
              aktivnyInvesticnyVariant
            }
          />

        </div>
      </div>

      <InvesticneExportPonukaPdfModal
        jeOtvoreny={
          investPdfModalOtvoreny
        }
        nazovSuboruPdf={
          nazovSuboruInvestPdf
        }
        setNazovSuboruPdf={
          setNazovSuboruInvestPdf
        }
        menoKlientaPdf={
          menoKlientaInvestPdf
        }
        setMenoKlientaPdf={
          setMenoKlientaInvestPdf
        }
        pdfSekcie={
          investPdfSekcie
        }
        setPdfSekcie={
          setInvestPdfSekcie
        }
        dostupnostSekcii={
          dostupnostInvestPdfSekcii
        }
        generujeSa={
          investPdfGenerujeSa
        }
        chyba={
          investPdfChyba
        }
        onZavriet={
          zavriInvestPdfModal
        }
        onPotvrdit={
          vygenerujInvesticnuPonukuPdf
        }
      />
    </>
  );
}